<div id="filter-chip-container" class="hmf-mb-xs hmf-mb-lg-0">
	<div
		class="hmf-display-flex filter-chip-slider"
		[class.hmf-flex-wrap]="wrapChips()"
	>
		<div class="mobile-filter-chips hmf-display-flex hmf-align-items-center hmf-flex-wrap hmf-mx-s hmf-mx-lg-0 hmf-my-m hmf-my-lg-0">
			@for (filterType of formattedSelectedFilters() | keyvalue; track $index + filterType.key) {
				@for (filterLabel of filterType.value; track $index + filterLabel.value) {
					<hmf-global-chips
						class="filter-chip hmf-px-0"
						[label]="filterLabel.label"
						[showCancelSign]="true"
						[size]="'small'"
						[type]="'neutral'"
						[variant]="'outline'"
						(handleChipClick)="removeFilter(filterType.key, filterLabel.value)"
						(handleClose)="removeFilter(filterType.key, filterLabel.value)">
					</hmf-global-chips>
				}
			}
			@if (!isSelectedFilterEmpty()) {
				<button hmf-action-text
						variant="secondary"
						class="clear-all-button hmf-align-items-center"
						altText="Clear all filters"
						ariaLabel="Clear all filters"
						(click)="removeFilters()">
					Clear All
				</button>
			}
		</div>
	</div>
</div>
